import { notification } from 'antd';
import moment from 'moment';
import momentTz from 'moment-timezone';

class UIHelper {
  static openNotificationWithIcon = (type, message, description) => {
    notification.config({
      duration: 10,
    });
    notification[type]({
      message,
      description,
    });
  };
  static serverError = () => {
    notification.config({
      duration: 4,
    });
    notification['error']({
      message: 'Errore, per favore contatta la direzione ',
    });
  };

  static getListRoute = (pathname, skipPathsLength = 2) => {
    const split = pathname.split('/').filter(Boolean);
    const mainList = split.slice(0, split.length - skipPathsLength);
    return `/${mainList.join('/')}`;
  };

  static formatedDate = (data, format = 'DD MMMM YYYY') => {
    return moment(data).locale('it').format(format);
  };

  static formatedDateWithTimezone = (date, format = 'DD MMMM YYYY') => {
    return momentTz(date).tz('CET').format(format);
  };

  static typeNumber = (evt) => {
    let key = evt.keyCode || evt.which;
    key = String.fromCharCode(key);
    if (key.length === 0) return;

    if (!/^[0-9,\b]+$/.test(evt.key)) {
      evt.preventDefault();
    }
  };

  static typeInteger = (evt) => {
    let key = evt.keyCode || evt.which;
    key = String.fromCharCode(key);
    if (key.length === 0) return;

    if (!/^[0-9\b]+$/.test(evt.key)) {
      evt.preventDefault();
    }
  };

  static correctionNumber = (field) => {
    try {
      const res = parseFloat(field.toString().replace(',', '.'));
      if (isNaN(res)) {
        return 0;
      }
      return Number(res);
    } catch (e) {
      return 0;
    }
  };

  static removeDot = (field) => {
    if (typeof field === 'string') {
      return field.replace('.', '');
    }
    return field;
  };

  static formatedNumber = (num) => {
    try {
      return num.replace(/[.,]00$/, '');
    } catch (e) {
      return 0;
    }
  };

  static percentage(percent, total) {
    return Number(((percent / 100) * total).toFixed(2));
  }

  static assignTire = (columns) => {
    columns?.map((i) => {
      if (!i.render) {
        i.render = (data, row) => {
          if (typeof data === 'number') {
            return data;
          }
          return data || '-';
        };
      } else {
        const oldRender = i.render;
        i.render = (data, row) => {
          const renderedData = oldRender(data, row);
          if (typeof renderedData === 'number') {
            return renderedData;
          }
          return renderedData || '-';
        };
      }
      return i;
    });

    return columns;
  };

  static replaceDotToComma = (value) => {
    if (!value) {
      return value;
    }
    const v = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    return v.replace ? v.replace('.', ',') : v;
  };

  static numberWithDot(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  static showAnalyticsError = (e) => {
    const dayErrors = e?.response?.data?.by_date_from_ly || [];
    const dayErrors2 = e?.response?.data?.by_date_from_ytd || [];
    const dayErrors3 = e?.response?.data?.by_date_to_ly || [];
    const dayErrors4 = e?.response?.data?.by_date_to_ytd || [];
    const showErrors = [];
    if (dayErrors.length) {
      showErrors.push('Periodo LY Dal ' + dayErrors.join(', '));
    }
    if (dayErrors2.length) {
      showErrors.push('Periodo YTD Dal ' + dayErrors2.join(', '));
    }
    if (dayErrors3.length) {
      showErrors.push('Periodo LY Al ' + dayErrors3.join(', '));
    }
    if (dayErrors4.length) {
      showErrors.push('Periodo YTD Al ' + dayErrors4.join(', '));
    }
    return showErrors;
  };

  static getSelectContainerProp = (element = 'parentElement', customElement = false) => {
    return {
      getPopupContainer: e => customElement ? element : e[element],
    };
  };

  static getSelectSearchProps = (optionFilterProp = 'title') => {
    return {
      optionFilterProp,
      showSearch: true,
      filterOption: (input, option) =>
        option.children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0,
    };
  };
}

export default UIHelper;
